import React from 'react';
import './Staff.css';
import consultantImg from './assets/consultant.jpg';
import labTechImg from './assets/lab-technologist.jpg';
import nurseImg from './assets/specialist-nurse.jpg';
import profImg from './assets/prof.jpg';
import ITImg from './assets/IT.jpg';
import GroundImg from './assets/ground.jpg';
import teamImg from './assets/team.jpg'; // 👈 Import your team image


const staffMembers = [
  {
    image: profImg,
    name: 'Prof. Grace Irimu',
    position: 'Kidney Specialist & Implementation Scientist. Professor of Health Systems and Quality Care',
    bio: `Prof. Grace Irimu is a distinguished paediatrician, kidney specialist, and Professor of Health Systems and Quality Improvement at the University of Nairobi. A holder of a PhD in Public Health, she has dedicated her career to strengthening clinical care and health systems in Kenya. She formerly served as Chair of the Department of Paediatrics and Child Health at the University of Nairobi.

For over 20 years, she has collaborated with the KEMRI-Wellcome Trust Research Programme to develop and promote evidence-based clinical guidelines that have been adopted nationally. Her work has significantly contributed to improved quality of care in public hospitals. In 2021, The Lancet named her among the most influential doctors in health and medicine during Black History Month.

Prof. Irimu has led the development and nationwide scaling of the Ministry of Health’s Basic Paediatric Protocols, ETAT+ (Emergency Triage Assessment and Treatment PLUS), and the Comprehensive Newborn Care Protocols. She also played a key role in establishing the Clinical Information Network (CIN), which links 24 county hospitals to strengthen data-driven decision-making in child health.

She is the founder and Clinical Director of Mwangaza Wellness and Medical Centre (MWMC), a centre of excellence in the prevention and control of diabetes and hypertension. She has developed practical job aides and training materials to support primary care teams in managing these conditions, supported by a modern in-house laboratory.

Prof. Irimu is also deeply involved in maternal and child health. She leads a WhatsApp group of over 1,000 mothers, offering expert guidance on breastfeeding and complementary feeding, alongside other specialists.

With over 80 publications in respected international journals, Prof. Irimu continues to inspire change through her unwavering commitment to quality, evidence-based healthcare in Kenya and beyond.`
  },
  {
    image: labTechImg,
    name: 'Benson Maroko',
    position: 'Lab Technologist',
    bio: `Benson Maroko is a certified Medical Laboratory Technologist with a Diploma in Medical Laboratory Sciences from Kisii University. He plays a critical role in the accurate diagnosis and monitoring of patient health through quality laboratory testing and analysis.

Benson is highly skilled in various laboratory procedures including hematology, microbiology, parasitology, clinical chemistry, and histopathology. He is committed to upholding the highest standards of lab safety, quality control, and result accuracy.

With a keen eye for detail and a strong commitment to patient outcomes, Benson contributes significantly to the efficiency and reliability of our diagnostic services.`,
    roles: [
      'Conducts diagnostic tests with precision',
      'Manages laboratory equipment and results processing',
      'Ensures accuracy and timeliness of patient reports'
    ]
  },
  {
    image: consultantImg,
    name: 'Jackline Munene',
    position: 'Clinician, Specialist in Diabetes & Hypertension at PHC',
    bio: `Jackline Karimi is a qualified Clinical Officer with a Diploma in Clinical Medicine from the Kenya Medical Training College (KMTC). She brings a strong passion for patient care, preventive health, and evidence-based medical care.

With a solid foundation in clinical medicine, Jackline is skilled in conducting patient assessments, diagnosing common illnesses, and implementing treatment plans in accordance with national health guidelines. Her calm demeanor, professionalism, and dedication to service make her a valued member of our medical team.

She is particularly passionate about community health outreach, patient education, and ensuring quality care is accessible to all.`,
    roles: [
      'Oversees patient diagnosis and treatment planning',
      'Provides expert consultation for chronic disease management',
      'Guides clinical protocols and quality assurance'
    ]
  },
  {
    image: nurseImg,
    name: 'Rose Mwangi',
    position: 'Nurse, Specialist in Diabetes & Hypertension at PHC',
    bio: `Rose Mwangi is a qualified community health nurse, holding a Diploma in Community Health Nursing from the Kenya Medical Training College (KMTC). With a deep commitment to primary health care and patient-centered service, she plays a key role in promoting wellness and preventive care within the community.

Rose brings experience in both clinical and outreach settings, combining hands-on nursing care with community engagement. Her passion lies in empowering individuals and families through health education, chronic disease management, and maternal and child health support.

At Mwangaza Wellness & Medical Centre, Rose is known for her compassion, professionalism, and strong advocacy for holistic wellness. She supports patient education initiatives, chronic illness monitoring (especially diabetes and hypertension), and collaborates closely with physicians and patients to ensure continuity of care.

Her calm demeanor and dedication to community well-being make her a valuable pillar in the delivery of inclusive, high-quality care.

`,
    roles: [
      'Provides patient education and follow-up care',
      'Supports counseling and wellness monitoring',
      'Coordinates with physicians for integrated care'
    ]
  },
  {
    image: ITImg,
    name: 'Kaheni Peter',
    position: 'IT Support Specialist',
    bio: `Kaheni Peter has currently finished his four year course awaiting graduation early October this year. He was  pursuing a Bachelor’s degree in Computer Science at Karatina University. He is an experienced IT support professional with a strong background in front-end and back-end development, artificial intelligence, machine learning, website design and development, and system integration.

Peter plays a key role in ensuring system reliability and providing technical support at the Centre. His expertise spans from building user-friendly web interfaces to implementing intelligent systems and maintaining enterprise-level IT infrastructure.

Driven by a passion for innovation and problem-solving, he contributes to the Centre’s digital transformation by offering smart, scalable, and secure technology solutions.`,
    roles: [
      'Maintains and troubleshoots IT infrastructure',
      'Supports digital health systems and staff devices',
      'Ensures system security and backups'
    ]
  },
  {
    image: GroundImg,
    name: 'James Mathenge',
    position: 'Groundsman',
    bio: `James Mathenge plays a key role in maintaining the physical environment of the facility. He ensures a clean, safe, and welcoming space for patients and staff.`,
    roles: [
      'Maintains cleanliness and landscaping of facility',
      'Supports logistics and site setup',
      'Ensures safety and hygiene standards'
    ]
  }
];

const OurStaffPage = () => {
  return (
    <div className="staff-page-container">
      <h2 className="staff-page-title">Meet Our Team</h2>


{/* 👇 Add team image right below heading */}
      <div className="team-image-wrapper">
        <img src={teamImg} alt="Our Team" className="team-image" />
      </div>



      {staffMembers.map((member, index) => (
        <div key={index}>
          <div className="staff-page-card">
            <div className="staff-page-left">
              <img src={member.image} alt={member.name} className="staff-page-image" />
            </div>
            <div className="staff-page-right">
              <h3 className="staff-page-name">{member.name}</h3>
              <p className="staff-page-position">{member.position}</p>
              <div className="staff-page-bio">
                {member.bio.split('\n\n').map((para, i) => (
                  <p key={i}>{para}</p>
                ))}
              </div>

              {/* Only show roles if they exist */}
              {member.roles && (
                <>
                  <h4 className="staff-page-roles-heading">Roles & Responsibilities</h4>
                  <ul className="staff-page-roles-list">
                    {member.roles.map((role, i) => (
                      <li key={i}>{role}</li>
                    ))}
                  </ul>
                </>
              )}
            </div>
          </div>

          {/* Red thick divider after each staff member */}
          <div className="staff-divider"></div>
        </div>
      ))}
    </div>
  );
};

export default OurStaffPage;
